<script>
import HsSectionCard from "@/base/hs-tableview/hs-section/hs-section-card.vue";
import HsFormCell from "@/base/hs-tableview/hs-section/hs-form-cell.vue";
import HsTag from "@/base/hs-tag/hs-tag.vue";
import CostCenters from "@/pages/personal/passengers/costCenters.vue";
import HsTeleport from "@/base/hs-teleport/hs-teleport.vue";
import Departments from "@/pages/personal/passengers/departments.vue";
import BusinessUnit from "@/pages/personal/passengers/businessUnit.vue";
import CExtendField from "@/components/c-extend-field/c-extend-field.vue";
import HsVanSwitch from "@/base/hs-switch/hs-van-switch.vue";
import {getMarkClassName} from "@/pages/personal/passengers/passenger-details/details";
import HsFormCellDes from "@/base/hs-tableview/hs-section/hs-form-cell-des.vue";

export default {
  props: {
    currentDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    XOrder: {
      type: Object,
      default: () => {
        return {}
      }
    },
    powerDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    OrderBusinessType: {
      type: Number,
      default: 0
    },
    submitChecked: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      ExtendFieldSettingsKey: '',
      ExtendFieldSettings: null,
      ExtendFieldSettingsValue: null,
    }
  },
  computed: {
    IsAdd () {
      return !(this.currentDetails.index >= 0)
    },
    UpTypeSetting() {
      let Edit = this.IsAdd && this.hasPower('我的:常旅客管理:因公非员工添加') && this.hasPower('我的:常旅客管理:因公添加')
      return {
        Show: true,
        Name:  this.IsAdd ? this.$t('SetAsStaff') : this.$t('TravelerType'),
        Edit: Edit,
        showSeparator: !Edit && !this.IsAdd,
      }
    },
    EmployeeNoSetting() {
      let Edit = this.IsAdd || this.hasPower('我的:常旅客管理:因公编辑')
      let Show = this.getSetting('常用配置:员工编号') && Number(this.currentDetails.TravelType) === 0 && Number(this.currentDetails.UpType) === 1 && this.OrderBusinessType !== 17;
      let Required = Show && this.getSetting('常用配置:员工编号:必填')
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Required && !this.currentDetails.EmployeeNo) {
        IsShowError = true
      }
      return {
        Show: Show,
        Name: this.$t('StaffNo'),
        ClassName: getMarkClassName('EmployeeNo'),
        Type: 'input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(null, false) : this.$t('Unmodifiable'),
        Required: Required,
        IsShowError: IsShowError,
        ErrTips: ErrTips,
      }
    },
    CostCenterSetting() {
      let Edit = this.IsAdd || this.hasPower('我的:常旅客管理:成本中心编辑')
      let Show = Number(this.currentDetails.TravelType) === 0 &&
          (this.currentDetails.UpType === 1 || this.OrderBusinessType !== 0) &&
          this.getSetting('常用配置:成本中心') && this.OrderBusinessType !== 17;
      let Required = Show && this.getSetting('常用配置:成本中心:必填')
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Show && Required && (!this.currentDetails.CostCenter || !this.currentDetails.CostCenter.Name)) {
        IsShowError = true
      }
      return {
        Show: Show,
        ClassName: getMarkClassName('CostCenter'),
        Name: this.$t('CostCenter'),
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: Edit,
        Required: Required,
        IsShowError: IsShowError,
        ErrTips: ErrTips,
      }
    },
    DepartmentSetting() {
      let Edit = this.IsAdd || this.hasPower('我的:常旅客管理:部门编辑')
      let Show = Number(this.currentDetails.TravelType) === 0 &&
          this.currentDetails.UpType === 1 &&
          this.getSetting('常用配置:部门') &&
          this.OrderBusinessType !== 17;

      let Required = Show && this.getSetting('常用配置:部门:必填')
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Show && Required && (!this.currentDetails.Department || !this.currentDetails.Department.Name)) {
        IsShowError = true
      }
      return {
        Show: Show,
        Name: this.$t('Department'),
        ClassName: getMarkClassName('Department'),
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: Edit,
        Required: Required,
        IsShowError: IsShowError,
        ErrTips: ErrTips,
      }
    },
    BusinessUnitSetting() {
      let Edit = this.IsAdd || this.hasPower('我的:常旅客管理:BU编辑')
      let Show = Number(this.currentDetails.TravelType) === 0 &&
          this.currentDetails.UpType === 1 && this.getSetting('常用配置:BU')  && this.OrderBusinessType !== 17;

      let Required = Show && this.getSetting('常用配置:BU:必填')
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Show && Required && (!this.currentDetails.BusinessUnit || !this.currentDetails.BusinessUnit.Name)) {
        IsShowError = true
      }
      return {
        Show: Show,
        Name: this.getSetting('常用配置:BU名称'),
        ClassName: getMarkClassName('BusinessUnit'),
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: Edit,
        Required: Required,
        IsShowError: IsShowError,
        ErrTips: ErrTips,
      }
    },
    ExtendField1Setting() {
      let Setting = this.getSetting('员工配置:扩展字段1')
      return this._getExtendFieldSetting('ExtendField1', this.currentDetails.ExtendField1, Setting)
    },
    ExtendField2Setting() {
      let Setting = this.getSetting('员工配置:扩展字段2')
      return this._getExtendFieldSetting('ExtendField2', this.currentDetails.ExtendField2,  Setting)
    },
    ExtendField3Setting() {
      let Setting = this.getSetting('员工配置:扩展字段3')
      return this._getExtendFieldSetting('ExtendField3', this.currentDetails.ExtendField3,  Setting)
    },
    ExtendField4Setting() {
      let Setting = this.getSetting('员工配置:扩展字段4')
      return this._getExtendFieldSetting('ExtendField4', this.currentDetails.ExtendField4,  Setting)
    },
    ExtendField5Setting() {
      let Setting = this.getSetting('员工配置:扩展字段5')
      return this._getExtendFieldSetting('ExtendField5', this.currentDetails.ExtendField5,  Setting)
    },
  },
  methods: {
    _setUpType(val) {
      if (!this.UpTypeSetting.Edit) {
        return
      }
      console.log(val)
      this.currentDetails.UpType = val ? 1 : 2
      this.$emit('update:currentDetails', this.currentDetails)
    },

    /** 打开成本中心选择框 */
    _openCostCenterPicker() {
      this.$refs.CostCenters && this.$refs.CostCenters.open()
    },

    /** 选择成本中心 */
    _setCostCenter(item) {
      this.currentDetails.CostCenter = item ? {...item} : null
      this.$emit('update:currentDetails', this.currentDetails)
    },

    /** 打开部门选择框 */
    _openDepartmentPicker() {
      this.$refs.Departments && this.$refs.Departments.open()
    },

    /** 设置部门 */
    _setDepartment(item) {
      this.currentDetails.Department = item ? {...item} : null
      this.$emit('update:currentDetails', this.currentDetails)
    },

    /** 打开BU选择框 */
    _openBusinessUnitPicker() {
      this.$refs.BusinessUnit && this.$refs.BusinessUnit.open()
    },

    /** 设置BU */
    _setBusinessUnit(item) {
      this.currentDetails.BusinessUnit = item ? {...item} : null
      this.$emit('update:currentDetails', this.currentDetails)
    },

    _getExtendFieldSetting(key, val, Setting) {
      let Edit = true
      let ExtendFieldType = Number(Setting.ExtendFieldType)
      let Show = this.OrderBusinessType !== 17 && Number(this.currentDetails.TravelType) === 0 && this.currentDetails.UpType === 1 && Setting.IsDisplayExtendField;
      let Required = Show && Setting.IsRequiredExtendField
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked && Show && Required && !val) {
        IsShowError = true
      }
      return {
        Show: Show,
        Name: Setting.ExtendFieldName,
        ClassName: getMarkClassName(key),
        Type: ExtendFieldType === 0 ? 'input' : 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(ExtendFieldType, false) : this.$t('Unmodifiable'),
        ShowLogo: ExtendFieldType !== 0,
        clearable: ExtendFieldType === 0,
        Required: Required,
        IsShowError: IsShowError,
        ErrTips: ErrTips,
        Setting,
        ExtendFieldType
      }
    },

    _openExtendFieldPicker(key) {
      let keys = {
        ExtendField1: 'ExtendField1Setting',
        ExtendField2: 'ExtendField2Setting',
        ExtendField3: 'ExtendField3Setting',
        ExtendField4: 'ExtendField4Setting',
        ExtendField5: 'ExtendField5Setting'
      }
      this.ExtendFieldSettingsKey = key
      this.ExtendFieldSettings = {
        ...(this[keys[key]] && this[keys[key]].Setting || {})
      }
      if (this.ExtendFieldSettings && this.ExtendFieldSettings.ExtendFieldType === 0) { // 输入类型不可选择
        return
      }
      this.ExtendFieldSettingsValue = this.currentDetails[key]
      this.$refs.RefsCExtendField && this.$refs.RefsCExtendField.open()
    },

    // 扩展字段选中回调
    mixinExtendFieldSettingsCallback(val, key = this.ExtendFieldSettingsKey) {
      this.currentDetails[key] = val
      this.$emit('update:currentDetails', this.currentDetails)
      this.$forceUpdate()
    },
    _getUpTypeDes() {
      let obj = {
        1: this.$t('Staff'),
        2: this.$t('NonStaff'),
      }
      let UpType = this.currentDetails.UpType
      return obj[UpType] || '--'
    },

    _toastExtendFieldErrTips(Setting) {
      this.$toast(this.$getPlaceholderErrTips(Number(Setting.ExtendFieldType), true, Setting.Name))
    },

    localCheck() {
      // 员工编号
      if (this.EmployeeNoSetting.Show && this.EmployeeNoSetting.IsShowError) {
        this.$toast(this.$t('PleaseFill_x', 'function', [this.EmployeeNoSetting.Name]))
        return this.EmployeeNoSetting.ClassName
      }
      // 成本中心
      if (this.CostCenterSetting.Show && this.CostCenterSetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.CostCenterSetting.Name]))
        return this.CostCenterSetting.ClassName
      }
      // 部门
      if (this.DepartmentSetting.Show && this.DepartmentSetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.DepartmentSetting.Name]))
        return this.DepartmentSetting.ClassName
      }
      // BU
      if (this.BusinessUnitSetting.Show && this.BusinessUnitSetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.BusinessUnitSetting.Name]))
        return this.BusinessUnitSetting.ClassName
      }
      // 扩展字段1
      if (this.ExtendField1Setting.Show && this.ExtendField1Setting.IsShowError) {
        this._toastExtendFieldErrTips(this.ExtendField1Setting)
        return this.ExtendField1Setting.ClassName
      }
      // 扩展字段2
      if (this.ExtendField2Setting.Show && this.ExtendField2Setting.IsShowError) {
        this._toastExtendFieldErrTips(this.ExtendField2Setting)
        return this.ExtendField2Setting.ClassName
      }
      // 扩展字段3
      if (this.ExtendField3Setting.Show && this.ExtendField3Setting.IsShowError) {
        this._toastExtendFieldErrTips(this.ExtendField3Setting)
        return this.ExtendField3Setting.ClassName
      }
      // 扩展字段4
      if (this.ExtendField4Setting.Show && this.ExtendField4Setting.IsShowError) {
        this._toastExtendFieldErrTips(this.ExtendField4Setting)
        return this.ExtendField4Setting.ClassName
      }
      // 扩展字段5
      if (this.ExtendField5Setting.Show && this.ExtendField5Setting.IsShowError) {
        this._toastExtendFieldErrTips(this.ExtendField5Setting)
        return this.ExtendField5Setting.ClassName
      }
    }
  },
  components: {
    HsFormCellDes,
    HsVanSwitch,
    CExtendField,
    BusinessUnit, Departments,
    HsTeleport,
    CostCenters,
    HsTag, HsFormCell,
    HsSectionCard
  }
}
</script>

<template>
  <hs-section-card :title="$t('CompanyInfo')">
    <div class="details">
      <!--员工非员工-->
      <hs-form-cell
          v-if="UpTypeSetting.Show"
          :title="UpTypeSetting.Name"
          :show-separator="UpTypeSetting.showSeparator"
          :edit="UpTypeSetting.Edit"
      >
        <div class="cell" v-if="IsAdd">
          <hs-van-switch
              :value="currentDetails.UpType === 1"
              size="25"
              @change="_setUpType"
              :active-color="UpTypeSetting.Edit ? '#f0182a' : '#F9A0A8'"
              :inactive-color="UpTypeSetting.Edit ? '#e3e1e1' : '#e3e1e1'"
          />
        </div>
        <div class="cell" style="justify-content: flex-start" v-else>{{_getUpTypeDes()}}</div>
      </hs-form-cell>
      <!--员工编号-->
      <hs-form-cell
          v-if="EmployeeNoSetting.Show"
          :class="EmployeeNoSetting.ClassName"
          :title="EmployeeNoSetting.Name"
          v-model="currentDetails.EmployeeNo"
          :type="EmployeeNoSetting.Type"
          :edit="EmployeeNoSetting.Edit"
          :placeholder="EmployeeNoSetting.Placeholder"
          :errTips="EmployeeNoSetting.ErrTips"
          :required="EmployeeNoSetting.Required"
          :is-show-error="EmployeeNoSetting.IsShowError"
          clearable
      />
      <!--成本中心-->
      <hs-form-cell
          v-if="CostCenterSetting.Show"
          :class="CostCenterSetting.ClassName"
          @click="_openCostCenterPicker"
          :value="currentDetails.CostCenter && currentDetails.CostCenter.Name"
          :title="CostCenterSetting.Name"
          :type="CostCenterSetting.Type"
          :placeholder="CostCenterSetting.Placeholder"
          :edit="CostCenterSetting.Edit"
          :showLogo="CostCenterSetting.ShowLogo"
          :errTips="CostCenterSetting.ErrTips"
          :required="CostCenterSetting.Required"
          :is-show-error="CostCenterSetting.IsShowError"
      />
      <!--部门-->
      <hs-form-cell
          v-if="DepartmentSetting.Show"
          :class="DepartmentSetting.ClassName"
          @click="_openDepartmentPicker"
          :value="currentDetails.Department && currentDetails.Department.Name"
          :title="DepartmentSetting.Name"
          :type="DepartmentSetting.Type"
          :placeholder="DepartmentSetting.Placeholder"
          :edit="DepartmentSetting.Edit"
          :showLogo="DepartmentSetting.ShowLogo"
          :errTips="DepartmentSetting.ErrTips"
          :required="DepartmentSetting.Required"
          :is-show-error="DepartmentSetting.IsShowError"
      />
      <!--BU-->
      <hs-form-cell
          v-if="BusinessUnitSetting.Show"
          :class="BusinessUnitSetting.ClassName"
          @click="_openBusinessUnitPicker"
          :value="currentDetails.BusinessUnit && currentDetails.BusinessUnit.Name"
          :title="BusinessUnitSetting.Name"
          :type="BusinessUnitSetting.Type"
          :placeholder="BusinessUnitSetting.Placeholder"
          :edit="BusinessUnitSetting.Edit"
          :showLogo="BusinessUnitSetting.ShowLogo"
          :errTips="BusinessUnitSetting.ErrTips"
          :required="BusinessUnitSetting.Required"
          :is-show-error="BusinessUnitSetting.IsShowError"
      />

      <!--扩展字段1-->
      <hs-form-cell
          v-if="ExtendField1Setting.Show"
          :class="ExtendField1Setting.ClassName"
          @click="_openExtendFieldPicker('ExtendField1')"
          v-model="currentDetails.ExtendField1"
          :title="ExtendField1Setting.Name"
          :type="ExtendField1Setting.Type"
          :edit="ExtendField1Setting.Edit"
          :placeholder="ExtendField1Setting.Placeholder"
          :show-logo="ExtendField1Setting.ShowLogo"
          :clearable="ExtendField1Setting.clearable"
          :errTips="ExtendField1Setting.ErrTips"
          :required="ExtendField1Setting.Required"
          :is-show-error="ExtendField1Setting.IsShowError"
      />
      <!--扩展字段2-->
      <hs-form-cell
          v-if="ExtendField2Setting.Show"
          :class="ExtendField2Setting.ClassName"
          @click="_openExtendFieldPicker('ExtendField2')"
          v-model="currentDetails.ExtendField2"
          :title="ExtendField2Setting.Name"
          :type="ExtendField2Setting.Type"
          :edit="ExtendField2Setting.Edit"
          :placeholder="ExtendField2Setting.Placeholder"
          :show-logo="ExtendField2Setting.ShowLogo"
          :clearable="ExtendField2Setting.clearable"
          :errTips="ExtendField2Setting.ErrTips"
          :required="ExtendField2Setting.Required"
          :is-show-error="ExtendField2Setting.IsShowError"
      />
      <!--扩展字段3-->
      <hs-form-cell
          v-if="ExtendField3Setting.Show"
          :class="ExtendField3Setting.ClassName"
          @click="_openExtendFieldPicker('ExtendField3')"
          v-model="currentDetails.ExtendField3"
          :title="ExtendField3Setting.Name"
          :type="ExtendField3Setting.Type"
          :edit="ExtendField3Setting.Edit"
          :placeholder="ExtendField3Setting.Placeholder"
          :clearable="ExtendField3Setting.clearable"
          :show-logo="ExtendField3Setting.ShowLogo"
          :errTips="ExtendField3Setting.ErrTips"
          :required="ExtendField3Setting.Required"
          :is-show-error="ExtendField3Setting.IsShowError"
      />
      <!--扩展字段1-->
      <hs-form-cell
          v-if="ExtendField4Setting.Show"
          :class="ExtendField4Setting.ClassName"
          @click="_openExtendFieldPicker('ExtendField4')"
          v-model="currentDetails.ExtendField4"
          :title="ExtendField4Setting.Name"
          :type="ExtendField4Setting.Type"
          :edit="ExtendField4Setting.Edit"
          :placeholder="ExtendField4Setting.Placeholder"
          :clearable="ExtendField4Setting.clearable"
          :show-logo="ExtendField4Setting.ShowLogo"
          :errTips="ExtendField4Setting.ErrTips"
          :required="ExtendField4Setting.Required"
          :is-show-error="ExtendField4Setting.IsShowError"
      />
      <!--扩展字段1-->
      <hs-form-cell
          v-if="ExtendField5Setting.Show"
          :class="ExtendField5Setting.ClassName"
          @click="_openExtendFieldPicker('ExtendField5')"
          v-model="currentDetails.ExtendField5"
          :title="ExtendField5Setting.Name"
          :type="ExtendField5Setting.Type"
          :edit="ExtendField5Setting.Edit"
          :placeholder="ExtendField5Setting.Placeholder"
          :show-logo="ExtendField5Setting.ShowLogo"
          :clearable="ExtendField5Setting.clearable"
          :errTips="ExtendField5Setting.ErrTips"
          :required="ExtendField5Setting.Required"
          :is-show-error="ExtendField5Setting.IsShowError"
      />

      <hs-teleport to="body">
        <!-- 成本中心 -->
        <costCenters ref="CostCenters" @select="_setCostCenter" :details="currentDetails" :selected="currentDetails.CostCenter" />

        <!-- 部门 -->
        <departments ref="Departments" @select="_setDepartment" :details="currentDetails" :selected="currentDetails.Department" />

        <!-- businessUnit -->
        <businessUnit ref="BusinessUnit" @select="_setBusinessUnit" :details="currentDetails" :selected="currentDetails.BusinessUnit" />

        <!--扩展字段-->
        <c-extend-field
            ref="RefsCExtendField"
            :ExtendFieldSettingsKey="ExtendFieldSettingsKey"
            :ExtendFieldSettings="ExtendFieldSettings"
            :value="ExtendFieldSettingsValue"
            :OrderBusinessType="0"
            @delegate="mixinExtendFieldSettingsCallback"
        />
      </hs-teleport>
    </div>
  </hs-section-card>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.details{
  width: 100%;
  .cell{
    @extend .flex-end;
    width: 100%;
    color: $color_black_300;
  }
}
</style>
